import { Editor } from 'ckeditor5'
import { TrackChangesEditing } from 'ckeditor5-premium-features'
import * as R from 'ramda'

import { CommandName, PluginName } from '../types'

const CustomPluginMap: Partial<Record<PluginName, CommandName>> = {
  Placeholder: CommandName.INSERT_PLACEHOLDER,
  ImportNotesTemplate: CommandName.INSERT_IMPORT_NOTES_TEMPLATE,
}

export function enableTrackChangesForCustomPlugins(
  editor: Editor,
  removePlugins: PluginName[],
) {
  if (removePlugins.includes('TrackChanges')) {
    return
  }

  const trackChangesEditing = editor.plugins.get(
    'TrackChangesEditing',
  ) as TrackChangesEditing

  const pluginsToEnable = R.without<PluginName | undefined>(
    removePlugins,
    R.keys(CustomPluginMap),
  )

  pluginsToEnable.forEach((plugin) => {
    if (plugin && CustomPluginMap[plugin]) {
      trackChangesEditing.enableCommand(CustomPluginMap[plugin] as CommandName)
    }
  })
}

export function setEditorStyle({
  propName,
  propValue,
  editor,
}: {
  editor: Editor
  propName: string
  propValue: any
}) {
  editor.editing.view.change((writer) => {
    writer.setStyle(
      propName,
      propValue,
      editor.editing.view.document.getRoot() as any,
    )
  })
}

// https://ckeditor.com/docs/ckeditor5/latest/api/module_utils_translation-service.html#function-add
export function addTranslation(
  language: string,
  translations: {
    readonly [messageId: string]: string | ReadonlyArray<string>
  },
  getPluralForm?: (n: number) => number,
) {
  if (!global.window.CKEDITOR_TRANSLATIONS) {
    global.window.CKEDITOR_TRANSLATIONS = {}
  }

  if (!global.window.CKEDITOR_TRANSLATIONS[language]) {
    global.window.CKEDITOR_TRANSLATIONS[language] = {} as any
  }

  const languageTranslations = global.window.CKEDITOR_TRANSLATIONS[language]

  languageTranslations.dictionary = languageTranslations.dictionary || {}
  languageTranslations.getPluralForm =
    getPluralForm || languageTranslations.getPluralForm

  // Extend the dictionary for the given language.
  Object.assign(languageTranslations.dictionary, translations)
}
